export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-border bg-grain"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-10 flex flex-col md:flex-row items-center justify-between gap-4 font-mono text-xs text-muted-foreground">
        <div className="flex items-center gap-2">
          <span className="w-2 h-2 rounded-full bg-[hsl(var(--accent-green))] animate-pulse" />
          <span>
            <span className="text-foreground font-bold">dvassalloapps</span> ©{" "}
            {new Date().getFullYear()}
          </span>
        </div>

        <div
          data-testid="footer-credit"
          className="flex items-center gap-2 text-[11px] tracking-[0.15em] uppercase"
        >
          <span className="text-muted-foreground/70">design by</span>
          <span className="text-foreground font-bold tracking-tight normal-case text-sm">
            Daniel A. Vassallo
          </span>
        </div>

        <div className="flex items-center gap-6">
          <span>built with</span>
          <span className="text-[hsl(var(--accent-cyan))]">react</span>
          <span className="opacity-50">·</span>
          <span className="text-[hsl(var(--accent-green))]">fastapi</span>
          <span className="opacity-50">·</span>
          <span className="text-[hsl(var(--accent-magenta))]">mongo</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
